import { Resource } from 'react-admin'
import { CoproManagerDashboardMain } from './dashboard_copromanager'

const section_name = 'dashboard'

export const RoutesDashboard = (generateIconUrl) => [
  <Resource
    name={`${section_name}_copromanager`}
    list={CoproManagerDashboardMain}
    icon={generateIconUrl(section_name)}
    options={{
      label: 'Dashboard CM',
    }}
  />,
  <Resource name={`${section_name}_copromanager/copro_managers`} />,
  <Resource name={`modal:${section_name}_copromanager`} />,
]
